import TicketCommentContent from 'gcs-common/components/Tickets/TicketComments/TicketCommentContent/TicketCommentContent';
import { getCurrentUserId } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { useSelector } from 'react-redux';
import TicketMessageBubble from '../TicketMessageBubble/TicketMessageBuble';

interface TicketMessageCommentProps {
  authorId?: string;
  createdAt: string;
  html: string;
}

const TicketMessageComment = (props: TicketMessageCommentProps) => {
  const { authorId, createdAt, html } = props;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const currentUserId: string = useSelector(getCurrentUserId);
  const isFromMe = authorId === currentUserId;

  return (
    <TicketMessageBubble isFromMe={isFromMe} createdAt={createdAt}>
      {!isFromMe && <div className="font-medium text-accent-9 text-xs">Ersatzteil-Team</div>}
      <TicketCommentContent html={html} />
    </TicketMessageBubble>
  );
};

export default TicketMessageComment;
